import {
  FUNDS_FETCH_STARTED,
  FUNDS_FETCH_SUCCESS,
  FUNDS_FETCH_FAILURE,
} from "../actions/funds.action";

const initialState = {
  loading: false,
  error: null,
};

const fundsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FUNDS_FETCH_STARTED: {
      return {
        ...state,
        loading: true,
      };
    }
    case FUNDS_FETCH_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        loading: false,
        error: null,
      };
    }
    case FUNDS_FETCH_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    }

    default:
      return state;
  }
};

export default fundsReducer;
